module.exports = __webpack_public_path__ + "assets/images/EURUNFIT500.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/EURUNFIT500.png
// module id = 1378
// module chunks = 1